// src/components/common/Loader.jsx
// -----------------------------------------------------------------------------
// Simple reusable spinner shown while a page/component is fetching API data.
// Usage: {loading ? <Loader /> : <YourContent />}
// -----------------------------------------------------------------------------
import PropTypes from 'prop-types';
import './common.css';

export default function Loader({ label = 'Loading...' }) {
  return (
    <div className="afix-loader">
      <div className="afix-loader-spinner" />
      <span>{label}</span>
    </div>
  );
}

Loader.propTypes = {
  label: PropTypes.string,
};